import 'url-search-params-polyfill'
import Vue from 'vue'
import App from './App.vue'
import router, { nextRouteMap } from './router'
import store from './store'
import './plugins/pp-vue-library'
import breakpoints from '@/styles/breakpoints.scss'
import PpVueAnalytics from 'pp-vue-analytics'
import { datadogRum } from '@datadog/browser-rum'
import { getBookConfig } from '@/utils/bookConfig'
import trackEventMixin from '@/mixins/trackEventMixin'

Vue.config.productionTip = false

Vue.prototype.$ppUi = {
  isMobile: window.innerWidth < breakpoints.xs
}

Vue.prototype.$nextPage = function () {
  const nextRoute = nextRouteMap[this.$route.name]
  nextRoute && this.$router.push(nextRoute)
}

const params = getBookConfig()
const urlBasedFrame = params.get('urlBasedFrame') !== undefined ? params.get('urlBasedFrame') : 1
Vue.prototype.$urlBasedFrame = Boolean(+urlBasedFrame)
Vue.prototype.$originHost = params.get('originHost')
Vue.prototype.$practiceId = params.get('practiceId')
Vue.prototype.$gaId = params.get('gaId')
Vue.prototype.$useWidgetManager = params.get('useWidgetManager')
Vue.prototype.$locationIdFilter = params.get('locationId') ? +params.get('locationId') : null
Vue.prototype.$providerIdFilter = params.get('providerId') ? +params.get('providerId') : null
Vue.prototype.$appointmentTypeIdFilter = params.get('appointmentTypeId') ? params.get('appointmentTypeId') : null
Vue.prototype.$widgetOrigin = params.get('origin') ? params.get('origin') : null

Vue.prototype.$vuetify = {
  rtl: false,
  lang: {
    t: (val) => val
  },
  theme: {
    dark: false
  },
  icons: {}
}

const env = window.Cypress ? window.Cypress.env() : process.env

const practiceGaId = params.get('gaId')
const appGaId = env.VUE_APP_GA4_ID

if (appGaId) {
  Vue.use(PpVueAnalytics, router, {
    appGaId,
    practiceGaId,
    category: 'bookonline',
    clientGaId: params.get('gaClientId') || '',
    gacId: params.get('gacId') || '',
    gacGbId: params.get('gacGbId') || '',
    trackEventPrefix: 'book_online',
    practiceUuid: params.get('practiceUuid') || '',
    debug: process.env.VUE_APP_STAGE !== 'prd'
  })
}

Vue.mixin(trackEventMixin)

datadogRum.init({
  applicationId: '53e299bc-2f13-48d3-963b-9d5a39cda442',
  clientToken: 'pubaecc2bb5fa80030b341f0b4c07a5430a',
  env: process.env.VUE_APP_STAGE,
  version: process.env.VUE_APP_VERSION,
  sampleRate: 50,
  site: 'datadoghq.com',
  service: 'book-online-ui',
  useCrossSiteSessionCookie: true,
  trackFrustrations: true,
  beforeSend: (event, context) => {
    // collect a RUM resource's response headers
    if (event.type === 'resource' && event.resource.type === 'fetch') {
      event.context = { ...event.context, responseHeaders: context.response.headers }
    }
  }
})

datadogRum.addRumGlobalContext('practiceUuid', params.get('practiceUuid'))

datadogRum.startSessionReplayRecording()

const Instance = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

Instance.$router.push({ name: 'stepA' })
